import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetEvidenceCitationDocument,
  type GetEvidenceCitationQuery,
  type GetEvidenceCitationQueryVariables,
} from "~/features/changeRequests/gqls";
import { useTenant } from "~/features/tenant/context";

/** Per-evidence reference + citation, shown in the change-request Source Info section. */
export function useEvidenceCitation(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetEvidenceCitationQuery, GetEvidenceCitationQueryVariables>(GetEvidenceCitationDocument, {
    variables: { tenantId, id },
  });
}
